import React from 'react';
import RootSvg, { RootSvgProps } from './RootSvg';

export default function SvgHamburgerMenu(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect x="1" y="2" width="22" height="2.85726" rx="0.5" fill="black" />
      <rect
        x="1"
        y="10.5723"
        width="22"
        height="2.85726"
        rx="0.5"
        fill="black"
      />
      <rect
        x="1"
        y="19.1426"
        width="22"
        height="2.85726"
        rx="0.5"
        fill="black"
      />
    </RootSvg>
  );
}
